export default __webpack_public_path__ + "static/media/product_avtar_En.534e29b6.webp";